import {ActivatedRouteSnapshot, CanActivate, CanDeactivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {FlightGroupComponent} from './single/flight-group.component';

@Injectable()
export class FlightGroupActivateGuard implements CanActivate {
  constructor(private _router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const id = +route.url[1].path;
    if (isNaN(id)) {
      alert('Invalid flight group Id');
      this._router.navigate(['/flight-groups']);

      return false;
    }
    return true;
  }
}


@Injectable()
export class FlightGroupDeactivateGuard implements CanDeactivate<FlightGroupComponent> {
  canDeactivate(component: FlightGroupComponent): boolean {
    if (component.flightGroupForm.dirty) {
      let flightGroupFlightNumber = component.flightGroupForm.get('flightNumber').value || 'New Flight Group';
      return confirm(`Navigate away and lose all changes to flightGroup ${flightGroupFlightNumber}?`);
    }

    return true;

  }
}



// WEBPACK FOOTER //
// ./src/app/flight_group/flight-group-guard.service.ts